import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import CustomToast from "../../../Components/CustomToast";
import CatchBlockFunction from "../../../Components/hooks/CatchBlockFunction";
import { AxiosResponse } from "axios";
import {
  doGetFeaturedGalleryList,
  doGetGalleryList,
} from "../../../utils/request";
import { SelectPageNo, SelectPageSize, SelectSearch } from "./selector";

export function* doGetFeaturedGalleryRequest(action: { payload: any }) {
  yield delay(500);

  try {
    const response: AxiosResponse = yield call(doGetFeaturedGalleryList);
    if (response && !response.data) {
      CustomToast(response.data.message, "ERROR");
      return;
    }
    yield put(actions.setGalleryFeaturedList(response.data));
    yield call(action?.payload?.callback());
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* doGetGalleryListRequest(action: {
  payload: { callback: any };
}) {
  yield delay(500);

  try {
    const pageNo: number = yield select(SelectPageNo);
    const pageSize: number = yield select(SelectPageSize);
    const searchText: string = yield select(SelectSearch);
    const response: AxiosResponse = yield call(
      doGetGalleryList,
      `?pageNo=${pageNo}&pageSize=${pageSize}${
        searchText.length > 0 ? "&search=" + searchText : ""
      }`
    );
    // if (response && !response.data.statusCode) {
    if (response && !response.status) {
      CustomToast(response.data.message, "ERROR");
      return;
    }
    yield put(
      actions.setTotalRow(response.data.meta ? response.data.meta.total : 0)
    );
    yield put(actions.setGalleryList(response.data.results));
    yield put(actions.setGalleryTitleList(response.data.title));
    yield call(action?.payload?.callback());
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}

export function* GalleryRepoSaga() {
  yield takeLatest(actions.doGetFeaturedPhotos, doGetFeaturedGalleryRequest);
  yield takeLatest(actions.doGetGallery, doGetGalleryListRequest);
}
